<!-- <div class="preloader" [hidden]="load">
  <div class="loading">
      <img src="assets/images/loader/loader.svg" alt="">
  </div>
</div> -->

<app-loading [hidden]="load"></app-loading>

<section class="page-title page-title-layout3 text-center bg-overlay bg-parallax " style="background-size: cover; background-position: center center;">
    <div class="container">
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
                <h1 class="pagetitle__heading mb-10">Vacancy</h1>
                <!--<nav>
                <ol class="breadcrumb justify-content-center mb-0">
                    <li class="breadcrumb-item"><a routerLink="/home">home</a></li>
                    <li aria-current="page" class="breadcrumb-item active">Research-Team</li>
                </ol>
            </nav>-->
            </div>
        </div>
    </div>
</section>

<section class="portfolio-layout3">
    <div class="container">
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-3">
                <ul class="portfolio-filter  justify-content-center list-unstyled" style="padding: 11px;">
                    <li [ngClass]="{'active2': selectedItem == null}" routerLink="/Vacancy"><a>All Scholarships</a></li>
                    <li *ngFor="let item of arrayVecancyCategory" [ngClass]="{'active2': selectedItem == item.postID}">
                      <a style="cursor: pointer;" routerLink="/vacancy/{{item.postID}}" (click)="getVecancy(item.postID)">{{item.postTitle}}</a>
                    </li>
                </ul>
            </div>

            <div class="row col-sm-12 col-md-12 col-lg-9" style="min-height: 400px;">

                <div class="col-sm-12 col-md-12 col-lg-12" *ngFor="let item of arrayVecancy">
                    <div class="job-item" style="padding: 21px 21px 30px;">
                        <div class="row">
                            <div class="col-sm-12 col-md-12 col-lg-9">
                             <div class="job-item__meta">
                                <h3 class="job-item__title">{{item.postTitle}}</h3>
                            </div>
                            <div class="job-item__meta">
                              <span class="job-item__type" style="margin-bottom: 0 !important;">{{item.vecancyState}}</span>
                              <span class="job-item__location" style="font-weight: bold;"> <a>{{item.vecancyPeriod}}</a><a>{{item.vecancyDate}}</a></span>
                            </div>
                            </div>

                            <div *ngIf="item.postFile" class="col-sm-12 col-md-12 col-lg-3 d-flex justify-content-end btn-wrap">
                              <a target="_blank" href="{{url}}{{item.postFile}}" class="btn btn__secondary action__btn-contact">Details</a>
                          </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>
